import { MenuTreeNode } from 'graphql/types';

/**
 * 菜单树是「该账号在当前客户配置下真正可访问的页面」的唯一来源。
 *
 * 它比权限码多一层客户级过滤：例如客户的「允许查询异常称重信息」关闭时，服务端会把
 * portal:weighing-query 从菜单树剔除，但账号的权限码集合里仍然有这个码。
 * 路由放行与兜底跳转若只看权限码，就会落到菜单里不存在的页面，页面挂载即被服务端拒绝、弹无权限。
 */

/** 递归找到菜单树中第一个有 resourcePath 的叶子节点 */
export const findFirstLeafPath = (nodes: MenuTreeNode[]): string | null => {
    for (const node of nodes) {
        if (node.resourcePath) return node.resourcePath;
        if (node.children && node.children.length > 0) {
            const found = findFirstLeafPath(node.children);
            if (found) return found;
        }
    }
    return null;
};

/** 收集菜单树中全部带 resourcePath 的节点路径 */
export const collectLeafPaths = (nodes: MenuTreeNode[]): Set<string> => {
    const paths = new Set<string>();
    const walk = (list: MenuTreeNode[]) => {
        for (const node of list) {
            if (node.resourcePath) paths.add(node.resourcePath);
            if (node.children && node.children.length > 0) walk(node.children);
        }
    };
    walk(nodes);
    return paths;
};
